export const environment = {
  production: true,
  backendUrl: 'https://bobbele.nw.r.appspot.com/api/',
  optimization: true,
  outputHashing: "all",
  sourceMap: false,
  buildOptimizer: true,
};
